<template>
    <div>
        <SkeletonBase has-title />
        <div class="md:grid md:grid-cols-2 md:gap-4 md:mb-2.5">
            <SkeletonPayment
                v-for="n in 2"
                :key="n"
            />
        </div>
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';
import SkeletonPayment from '@/components/skeletons/SkeletonPayment.vue';

export default {
    components: {
        SkeletonBase,
        SkeletonPayment
    },
};
</script>
